import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Signal } from "@angular/core";
import { APP_CONFIG, AppConfig, UserRole } from "@shared/index";

export interface ChangeRoleAPIResponse{
    "message": string,
    "updated_count": number
}
 

@Injectable({
    providedIn:'root'
})
export class RoleChangeTestAPIService{
    constructor(private readonly http:HttpClient,@Inject(APP_CONFIG) private readonly config:Signal<AppConfig | null>){};

    changeRole(role:UserRole){
      let apiUrl=this.config()?.csesServiceUrl+"authentication/test-update-role/";

      let payload={
        role
      };

     return this.http.patch<ChangeRoleAPIResponse>(apiUrl,payload);   
    }

}